<div class="flex-column flex-fill">
  <!-- TODO: MOve this chunk to a separate component, and add a CLOSE button to hide---------------------------------------->
  @if (stdCfgSharedServiceService.ValidationErrors.size > 0 && this.stdCfgSharedServiceService.editMode && this.showValidationErrors) {
  <div class="row mb-3" style="max-height:12em; overflow-y: scroll;">
    <div class="col-12">
      <div class="alert alert-danger mb-0" role="alert">
        <ul>
          @for (itemMessages of stdCfgSharedServiceService.ValidationErrors | keyvalue: null; track itemMessages.key) {
          <li>
            {{itemMessages.key}}
            <ul>
              @for (message of itemMessages.value; track message) {
              <li>
                {{message}}
              </li>
              }
            </ul>
          </li>
          }
        </ul>
      </div>
    </div>
  </div>
  }
  <!-- TODO: MOVE ABOVE CHUNK TO SEPARATE COMPONENT -------------------------------------------------------------------------->
  <div class="stg-cfg-details-header">Standard Configurations</div>
  <ag-grid-angular #agGridFF
    class="ag-theme-balham"
    style="height: 100%;"
    (gridReady)="onGridReady($event)"
    [gridOptions]="gridOptions"
    (selectionChanged)="onSelectionChanged($event)"
    (cellValueChanged)="onCellValueChanged($event)"
    (cellEditingStarted)="onCellEditingStarted($event)">
  </ag-grid-angular>
</div>

@if (dialogOpened) {
<kendo-dialog
  title="Please Confirm"
  (close)="confirmCancel()"
  [width]="450">
  <p style="margin: 30px; text-align: center;">
    You have unsaved changes.
  </p>
  <kendo-dialog-actions>
    <button type="button" kendoButton (click)="confirmSave()" themeColor="primary">
      Save
    </button>
    <button type="button" kendoButton (click)="confirmDontSave()">
      Don't Save
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
}